export * from './http';
export * from './schemas/common';
export * from './schemas/domain';

export * from './endpoints/auth';
export * from './endpoints/users';
export * from './endpoints/packages';
export * from './endpoints/activations';
export * from './endpoints/income';
export * from './endpoints/team';
export * from './endpoints/wallet';
export * from './endpoints/withdrawals';
export * from './endpoints/deposits';
export * from './endpoints/ranks';
export * from './endpoints/support';
export * from './endpoints/admin';
export * from './endpoints/walletAuth';
export * from './endpoints/lds1Purchase';

import { activationsApi } from './endpoints/activations';
import { adminApi } from './endpoints/admin';
import { authApi } from './endpoints/auth';
import { depositsApi } from './endpoints/deposits';
import { incomeApi } from './endpoints/income';
import { lds1PurchaseApi } from './endpoints/lds1Purchase';
import { packagesApi } from './endpoints/packages';
import { ranksApi } from './endpoints/ranks';
import { supportApi } from './endpoints/support';
import { teamApi } from './endpoints/team';
import { usersApi } from './endpoints/users';
import { walletApi } from './endpoints/wallet';
import { walletAuthApi } from './endpoints/walletAuth';
import { withdrawalsApi } from './endpoints/withdrawals';

export const api = {
  auth: authApi,
  users: usersApi,
  packages: packagesApi,
  activations: activationsApi,
  income: incomeApi,
  team: teamApi,
  wallet: walletApi,
  withdrawals: withdrawalsApi,
  deposits: depositsApi,
  ranks: ranksApi,
  support: supportApi,
  admin: adminApi,
  walletAuth: walletAuthApi,
  lds1Purchase: lds1PurchaseApi,
};

export type Api = typeof api;

/**
 * Stable query-key factory shared by both panels so cache invalidation lines
 * up across features.
 */
export const queryKeys = {
  session: ['session'] as const,
  dashboard: (panel: 'admin' | 'user') => ['dashboard', panel] as const,
  members: (query: unknown) => ['members', query] as const,
  member: (id: string) => ['member', id] as const,
  packages: () => ['packages'] as const,
  activations: (query: unknown) => ['activations', query] as const,
  income: (type: string, query: unknown) => ['income', type, query] as const,
  incomeSummary: () => ['income', 'summary'] as const,
  clubBProgress: () => ['income', 'alpha-club-b', 'progress'] as const,
  rewardTracker: (id: string) => ['income', 'reward-tracker', id] as const,
  team: (scope: string, query: unknown) => ['team', scope, query] as const,
  wallet: () => ['wallet'] as const,
  transactions: (query: unknown) => ['transactions', query] as const,
  withdrawals: (query: unknown) => ['withdrawals', query] as const,
  deposits: (query: unknown) => ['deposits', query] as const,
  ranks: () => ['ranks'] as const,
  tickets: (query: unknown) => ['tickets', query] as const,
  ticket: (id: string) => ['ticket', id] as const,
  news: () => ['news'] as const,
  downloads: () => ['downloads'] as const,
  settings: () => ['settings'] as const,
  cronLog: (query: unknown) => ['cron-log', query] as const,
  kyc: (query: unknown) => ['kyc', query] as const,
  dappRequests: (query: unknown) => ['dapp-requests', query] as const,
  myDappRequest: () => ['dapp-request', 'mine'] as const,
  lds1Purchases: (query: unknown) => ['lds1-purchases', query] as const,
};
